import { render } from "./LoginAdmin.vue?vue&type=template&id=0bdc4fb7&scoped=true"
import script from "./LoginAdmin.vue?vue&type=script&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=0bdc4fb7&scoped=true&lang=css"

import exportComponent from "/root/mymenucli/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdc4fb7"]])

export default __exports__